let currentZIndex = 1100;

export function nextZIndex() {
    currentZIndex += 1;
    return currentZIndex;
}
